import { IonButton, IonIcon } from "@ionic/react";
import { chevronBack } from "ionicons/icons";
import React from "react";
import { useHistory } from "react-router-dom";

interface BackButtonProps {
  buttonStyles?: string;
  iconStyles?: string;
  onClickButton?: () => void;
}

const BackButton: React.FC<BackButtonProps> = ({ buttonStyles }) => {
  let history = useHistory();
  return (
    <IonButton
      className={buttonStyles}
      onClick={() => {
        history.goBack();
      }}
    >
      <IonIcon className="ion-no-margin" icon={chevronBack} />
    </IonButton>
  );
};

export default BackButton;
